import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { IWorker, IWorkersFilter } from './workers.interface';
import { WorkersService } from './workers.service';
import { WorkersModalComponent } from './workers-modal/workers-modal.component';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../shared/services/auth.service';
// import { UserService } from '../../users-page/users/users.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
let self: any;

@Component({
  selector: 'app-workers',
  templateUrl: './workers.component.html',
  styleUrls: ['./workers.component.css']
})
export class WorkersComponent implements OnInit {
  workers: IWorker[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IWorkersFilter = {
    filters: {
      isDeleted: false
    },
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  querySubscription!: Subscription;
  sortOptions: any = {
    "lastname": 'Apellido asc',
    "-lastname": 'Apellido desc',
    "firstname": 'Nombre asc',
    "-firstname": 'Nombre desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;

  constructor(
    private _WorkersService: WorkersService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    // private _UserService: UserService,
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      if (params['action'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000)) && (params['action'] == 'NEW'))
        setTimeout(() => this.openNewWorkerModal());
    })
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.getWorkers(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getWorkers(true);
      }
    }, 1000);
  }

  getWorkers(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.workers = [];
      this.clearSelection();
    }
    this._WorkersService.getWorkers(this.filter).subscribe((workers: any) => {
      // console.log(workers)
      this.workers = _.concat(this.workers, workers);
      const filter: any = this.filter;
      this.thereAreMore = workers.length >= filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getWorkers();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
    this.querySubscription.unsubscribe();
  }

  sortWorkers(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getWorkers(true);
  }

  openFilter() {

  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getWorkers(true);
  }

  openNewWorkerModal() {
    this.openWorkerModal({});
  }

  openWorkerModal(worker: IWorker, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(WorkersModalComponent, config);
    self.dialogRef.componentInstance.worker = worker;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getWorkers(true);
    });
  }

  openDeleteWorkerConfirm(worker: IWorker, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Worker",
      message: "Esta seguro que desea eliminar '" + worker.lastname + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._WorkersService.deleteWorker(worker, hardDelete).subscribe(() => {
            if (hardDelete){
              this.getWorkers(true);
            } 
            else {
              worker.isDeleted = true;
              // refactor, ver como resolver la dependencia circular
              // this._UserService.deleteUser(worker._id || '', hardDelete).subscribe(() => { });
              this.getWorkers(true);
            }
          });
        }
      });
  }

  openRestoreWorkerConfirm(worker: IWorker) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Worker",
      message: "Esta seguro que desea restaurar '" + worker.lastname + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._WorkersService.restoreWorker(worker).subscribe(() => {
            worker.isDeleted = false;
            // refactor, ver como resolver la dependencia circular
            // this._UserService.restoreUser(worker._id || '').subscribe(() => { });
            this.getWorkers(true);
          });
        }
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.workers.every(worker => {
        const id = worker?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.workers.forEach(worker => {
        const id = worker?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}